
import { MixinsHomeClick } from '@xt/client/mixins/home'
import type { BtnCustomTextSwiperConfig } from '@xt/client/types/home'
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class SectionItemFifth extends Mixins(MixinsHomeClick) {
  @Prop() config: BtnCustomTextSwiperConfig

  theme: 'light' | 'dark' | 'custom' = 'light'
  styleVar: {
    '--color': string
    '--bg-color': string
    '--hover-color': string
    '--hover-bg-color': string
  } | null = null

  handleOpen() {
    if (this.config.event) {
      this.onClickEvent(this.config.event)
      return
    }
  }

  init() {
    if (!this.config.style || this.config.style === 'light') return

    if (this.config.style === 'dark') {
      this.theme = 'dark'
      return
    }

    this.theme = 'custom'

    const { color, background, hover } = this.config.style

    this.styleVar = {
      '--color': color,
      '--bg-color': background,
      '--hover-color': hover.color,
      '--hover-bg-color': hover.background
    }
  }

  created(): void {
    this.init()
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
